<template>

  <div 
    v-if="list"
    class="toast">  
    <transition-group name="toast-anim" tag="div">
    <div 
      v-for="(p, pk) in list"
      :key="p.id"
      :class="'item ' + p.type" 
      @click="remove(p.id)"
      >
      <!-- icon -->

      <!-- <i v-if="p.type == 'success'" class="st icon-success-round"></i>
      <i v-if="p.type == 'error'" class="st icon-warning-round"></i>
      <i v-if="p.type == 'info'" class="st icon-info"></i>
      <i v-if="p.type == 'warning'" class="st icon-warning-triangle"></i>
      <i v-if="p.type == 'progress'" class="st icon-time"></i> -->

      <span>{{ p.message }}</span>

      <!-- progress bar -->
      <div v-if="p.type === 'progress'" class="bar">
        <div class="bar__inner" :style="{ width: (p.progress || 0) + '%' }"></div>
      </div>

      <!-- close -->
      <!-- <i 
        v-if="p.type !== 'progress'"
        class="close icon-close-thin" 
        @click.stop="remove(p.id)"></i> -->

    </div>
    </transition-group>

  </div>

</template>


<script setup lang="ts">

const { list } = useToast();


const remove = (id) => {
  useToast().remove(id)
}


</script>
 

 
<style scoped>
   
.toast{
  position: fixed;
  top: 0;
  right: 10px;
  z-index: 1000000000;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  height: 100%;
  opacity: 0.9;
}

.toast .item{
  padding: 0.6rem 1rem;
  margin-top: 10px;
  border-radius: 7px;
  z-index: 1000000000000;
  width: 100%;
  bottom: auto;
  right: auto;
  /* opacity: 0.95; */
  text-align: left;
  font-size: 0.9rem;
  /* box-shadow: 0px 0px 60px rgb(0 0 0 / 20%); */
  box-shadow: 0 2px 4px 0 rgba(34, 36, 38, .12), 0 2px 10px 0 rgba(34, 36, 38, .15);
  /* background-color: #f6f6f6; */
  background-color: #333333;
  color: #fff;
  pointer-events: all;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: all .2s ease-in-out;
  gap: 10px;
}

.toast .item.error{
  /* background-color: #D25B50;
  color: white; */
  /* border: 1px solid #D25B5047; */
}

.toast .item.success{
  /* background-color: #008957; */
  /* border: 1px solid #00895747; */
  /* color: white; */
}

/* progress bar */
.toast .item .bar{
  width: 100%;
  height: 100%;
  margin-top: 4px;
  background: black;
  border-radius: 2px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0px;
  right: 0;
  opacity: 0.08;
  border-top: 1px solid #ffffff20;
}
.toast .item .bar__inner{
  width: 0%;
  height: 100%;
  transition: width .2s linear;
  background: #ffffff;
}


.item i.st{
  font-size: 1.2rem;
}
.item i.close{
  font-size: 1rem;
  margin-left: auto;
  color: #ffffff80;
}

/* colors */
.success{

}
.item.error{
  color: #ff470d;
}
/* .success i.st{
  color: #03c980;
  text-shadow: 0 0 15px #03c980, 0 0 55px #03c980, 0 0 105px #03c980;
}
.error i.st{
  color: #ff3d00;
  text-shadow: 0 0 15px #ff3d00, 0 0 55px #ff3d00, 0 0 105px #ff3d00;
}

.info i.st{
  color: #0081ff;
  text-shadow: 0 0 15px #0081ff, 0 0 55px #0081ff, 0 0 105px #0081ff;
}

.warning i.st{
  color: #ffbb33;
  text-shadow: 0 0 15px #ffbb33, 0 0 55px #ffbb33, 0 0 105px #ffbb33;
}

.progress i.st{
  color: #ff8855;
  text-shadow: 0 0 15px #ff8855, 0 0 55px #ff8855, 0 0 105px #ff8855;
} */

@media all and (max-width: 768px) {
  .toast{    
    left: 15%;
    right: 15%;
    max-width: 70%;
  }
}

/* Vue transition for toast items */
.toast-anim-enter-active,
.toast-anim-leave-active {
  /* Slightly longer duration for smoother fade */
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.toast-anim-enter-from,
.toast-anim-leave-to {
  opacity: 0;
  /* Slide a bit downward/upward depending on direction */
  transform: translateY(-8px);
}

.toast-anim-enter-to,
.toast-anim-leave-from {
  opacity: 1;
  transform: translateY(0);
}

/* movement when order changes */
.toast-anim-move {
  transition: transform 0.4s ease;
}

</style>